import { createAction } from '@reduxjs/toolkit';

export const updateMultipleItem = createAction('UPDATE_MULTIPLE_ITEM');
export const previousSelectedItems = createAction('PREVIOUS_SELECTED_ITEM');
export const currentSelectedItems = createAction('CURRENT_SELECTED_ITEM');
export const currentBundleSumarry = createAction('CURRENT_SUMMARY_ITEMS');
export const removeItem = createAction('REMOVE_ITEM');
export const createNewGuid = createAction('CREATE_NEW_GUID');
export const updatePreviousSelectedItems = createAction('UPDATE_PREVIOUS_SELECTED_ITEM');
